import flowRight from 'lodash/flowRight';
import {inject, observer} from 'mobx-react';
import React from 'react';

//components
import ElasticSearchBarDropdown from './ElasticSearchBarDropdown';

/**
 * Wires drop-downs of different modes to the environment.
 */
const SearchBarDropdownComponent = flowRight(
  inject('store'),
  observer
)(({onModeToggleClick, searchTerm, store}) => {
  const {explorerPage} = store;

  return (
    <ElasticSearchBarDropdown
      onModeToggleClick={onModeToggleClick}
      searchTerm={searchTerm}
      skipSearch={!explorerPage.canPerformSearch}
    />
  );
});

export default SearchBarDropdownComponent;
